
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { IStore } from '../../interfaces';
import { IMatchScarvesGroup, EnumSection, OrderMatchCompetition } from '../../interfaces/clientInterfaces';
import * as actions from '../../actions';
import { Helmet } from 'react-helmet';
import { IMatch, ITeam } from '../../interfaces/clientInterfaces';
import { Matches } from '../../utils/matches';
import { StyledHeader } from './Header';
import { ScarfCommentContainer } from './RMMatchGallery';
import { useAppDispatch } from '../../utils/modules';

interface IGalleryContainer {
	imgSrc: string;
}
const GalleryContainer = styled.div<IGalleryContainer>`
	font-family: Champions;
	flex: 1;
	display: flex;
	flex-direction: column;
	background: ${props => `url('../img/background/${props.imgSrc}.jpg') no-repeat center center fixed`}; 
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
`;

const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	overflow-y: auto;
	overflow-x: hidden;
`;

export const GroupContainer = styled.div<{
	$useMobileViewActive: boolean;
}>`
	margin: ${props => props.$useMobileViewActive ? 'auto auto 15px auto' : 'auto auto 30px auto'};
	width: calc(100% - 20px);
	padding: 10px;
`;

const ScarfContainer = styled.div`
	display: flex; 
	flex-direction: column;
	margin-top: 6px;
	max-height: auto;
	overflow: hidden;
`;
export const TitleContainer = styled.div<{
	$useMobileViewActive: boolean;
}>`
	display: flex;
	font-size: ${props => props.$useMobileViewActive ? '17px' : '20px'};
	flex-direction: column;
	img {
		max-height:${props => props.$useMobileViewActive ? '50px' : '65px'} !important;
		object-fit: contain;
		margin: 0;
	}
`;
const TitleSectionContainer = styled.div`
	margin: auto;
	text-shadow: 2px 2px 2px black;
`;


export const ImageRenderer = styled.img<{
	isMobileViewActive: boolean;
}>`
	max-width: ${props => props.isMobileViewActive ? '80vw' : '575px'};
	margin: 5px auto 5px auto;
`;

const ShieldImageRenderer = styled.img<{
	$useMobileViewActive: boolean;
}>`
	max-width: 575px;
	margin:  ${props => props.$useMobileViewActive ? '6px auto 4px auto;' : '10px auto 5px auto;'}
`;

const ResultContainer = styled.div<{
	$useMobileViewActive: boolean;
}>`
	display: flex;
	flex-direction: column;
	position: relative;
	font-size: ${props => props.$useMobileViewActive ? 30 : 45}px;
	font-family: 'Europa-Big';
	margin: 5px auto 5px auto;
`;

const ResultContainerRow = styled.div<{
	$useMobileViewActive: boolean;
}>`
	display: flex;
	position: relative;
	flex-flow: row wrap;
	justify-content: center;
`;

const ResultContainerQuarter = styled.div<{
	$useMobileViewActive: boolean;
}>`
	display: flex;
	width:  ${props => props.$useMobileViewActive ? 40 : 65}px;
	height:  ${props => props.$useMobileViewActive ? 40 : 65}px;
	img {
		max-height:  ${props => props.$useMobileViewActive ? 40 : 50}px;
		max-width: ${props => props.$useMobileViewActive ? 40 : 60}px;
		object-fit: contain;
	}
`;

const SEPARATOR_WIDTH_DESKTOP = 18;
const SEPARATOR_WIDTH_MOBILE = 10;
const SEPARATOR_HEIGHT_DESKTOP = 8;
const SEPARATOR_HEIGHT_MOBILE = 6;

const Separator = styled.div<{
	$useMobileViewActive: boolean;
}>`
	position: absolute;
	width:  ${props => props.$useMobileViewActive ? SEPARATOR_WIDTH_MOBILE : SEPARATOR_WIDTH_DESKTOP}px;
	height: ${props => props.$useMobileViewActive ? SEPARATOR_HEIGHT_MOBILE : SEPARATOR_HEIGHT_DESKTOP}px;
	left: ${props => props.$useMobileViewActive ? `calc(50% - ${SEPARATOR_WIDTH_MOBILE / 2}px)` : `calc(50% - ${SEPARATOR_WIDTH_DESKTOP / 2}px)`};
	top: ${props => props.$useMobileViewActive ? `calc(50% - ${SEPARATOR_HEIGHT_DESKTOP / 2}px)` : `calc(50% - ${SEPARATOR_HEIGHT_DESKTOP / 2}px)`};
	background-color: #F89504;
`;

const TieContainer = styled.div<{
	$useMobileViewActive: boolean;
}>`
	position: absolute;
	width 100%;
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
	color: #F89504;
	background-color: transparent;
	font-size: ${props => props.$useMobileViewActive ? 8 : 12}px;

`;
const ExtraTimeContainer = styled.div<{
	$useMobileViewActive: boolean;
}>`
	position: relative;
	left: ${props => props.$useMobileViewActive ? 'calc(50% - 8px)' : 'calc(50% - 12px)'};
	bottom:  ${props => props.$useMobileViewActive ? 'calc(-50% - 3px)' : 'calc(-50% - 3px)'};
`;

const PenaltyRenderer = styled.div<{
	$useMobileViewActive: boolean;
}>`
	position: absolute;
	bottom: 3px;
	font-size: ${props => props.$useMobileViewActive ? 9 : 11}px;

`;
const LocalPenaltyRenderer = styled(PenaltyRenderer)`
	${props => props.$useMobileViewActive && 'left: 2px;'};
	${props => !props.$useMobileViewActive && 'right: 55%'};
`;

const VisitantPenaltyRenderer = styled(PenaltyRenderer)`
	${props => props.$useMobileViewActive && 'right: 2px;'};
	${props => !props.$useMobileViewActive && 'left: 55%'};
`;

const ResultContainerShieldQuarter = styled(ResultContainerQuarter)<{
	backgroundColor: string;
}>`
	background-color: ${props => `#${props.backgroundColor}`};
	cursor: pointer;
`;
const ResultContainerResultQuarter = styled(ResultContainerQuarter)`
	background-color:#212121;
	color: #F89504;
`;

const NumberContainer = styled.div`
	margin: auto;
`;

const MatchResultContainer = styled.div`
	display: flex;
	flex-direction: row;
	max-width: 700px;
	margin: auto;
	flex-flow: row wrap;
`;

const MatchFilterContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex: 1;
	margin: auto;
	border-radius: 4px;
	background-color: rgba(255, 255, 255, 0.3);
	margin: 10px;
	flex-flow: row wrap;
`;

const ImageFilterSubContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	cursor: pointer;
`;

const StyledFilterImageHeader = styled(StyledHeader)`
	font-size: 14px;
	text-align: center;
	:hover {
		background-color: transparent;
		a {
			color: white;
		}
		i {
			color: white;
		}
	}
`;

const StyledFilterImageContainer = styled(StyledHeader)<{
	isSelected: boolean;
	isMobileView: boolean;
}>`
	cursor: pointer;
	font-size: 12px;
	width: ${props => props.isMobileView ? '50px' : '60px'};
	background-color: ${props => props.isSelected ? '#F89504' : 'transparent'};
	:hover {
		background-color: ${props => props.isSelected ? '#F89504 !important' : 'transparent !important;'};
	}
	a {
		color: ${props => props.isSelected ? 'white' : 'black'};
	}
	img {
		height: ${props => props.isMobileView ? '40px' : '50px'};
		display: flex;
		margin: auto;
		cursor: pointer;
	}
`;

const UCL_NAME = 'UEFA Champions League/European Cup';
const UEL_NAME = 'UEFA Europa League/UEFA Cup';
const COL_NAME = 'UEFA Conference League';
const UCW_NAME = 'UEFA Cup Winners´ Cup';
const USC_NAME = 'UEFA Super Cup';
const CWC_NAME = 'FIFA Club World Cup';
const FIC_NAME = 'Intercontinental Cup';
const CES_NAME = 'Copa del Rey';
// const FWC_NAME = 'FIFA World Cup';
// const UEC_NAME = 'UEFA Euro';
// const CAT_NAME = 'ÖFB Cup';
// const LIB_NAME = 'CONMBEBOL Libertadores';
// const SUD_NAME = 'CONMBEBOL Sudamericana';
// const CIT_NAME = 'Coppa Italia';


export default function MatchGallery() {

	const dispatch = useAppDispatch()

	const [imgNumber, setImgNumber] = useState(0);

	const matchScarfGroups = useSelector(
		(completeState: IStore): IMatchScarvesGroup[] => {
			return completeState.matches.currentMatchScarfGroups
		});

	const useMobileViewActive = useSelector(
		(completeState: IStore): boolean => {
			return completeState ? completeState.ui.isMobileViewActive : false
		});

	useEffect(() => {
		setImgNumber(Math.floor(Math.random() * 10) + 1);
		dispatch(actions.setSectionName(EnumSection.matches))
	}, [dispatch]);

	const renderTitleLogo = useCallback((matchScarf: IMatchScarvesGroup, title: string) => {
		if (!matchScarf.competition) {
			return null;
		}
		let code = `${matchScarf.competition.region_code}_${matchScarf.competition.competition_code}`;
		if (matchScarf.competition.isInternational) {
			code += `_${matchScarf.yearEnd}`;
		}
		return (
			<img
				title={title}
				src={`../../../img/shield/${code}.png`}
				alt={title}
			/>
		);
	}, []);

	const renderMatchScarves = useCallback((matchScarfGroup: IMatchScarvesGroup, index: number) => {
		let title = `${matchScarfGroup.yearEnd}`;

		if (matchScarfGroup.competition) {
			title += ` ${Matches.parseCompetitionTitleByYear(matchScarfGroup.competition, matchScarfGroup.yearEnd)}`;
			if (matchScarfGroup.matches.length > 0 && matchScarfGroup.matches[0].round) {
				title += ` ${Matches.getNameOfPhase(matchScarfGroup.matches[0].round)}`;
			}
		}	
		return (
			<GroupContainer key={index} $useMobileViewActive={useMobileViewActive}>		
				<TitleContainer $useMobileViewActive={useMobileViewActive}>
					<TitleSectionContainer>{renderTitleLogo(matchScarfGroup, title)}</TitleSectionContainer>
					<TitleSectionContainer>{title}</TitleSectionContainer>
				</TitleContainer>
		
				<MatchResultContainer>
					{matchScarfGroup.matches.map((x, i) => {
						return (
							<MatchResult
								yearEnd={matchScarfGroup.yearEnd}
								match={x}
								index={i}
								firstTeam={matchScarfGroup.firstTeam}
								secondTeam={matchScarfGroup.secondTeam}
								thirdTeam={matchScarfGroup.thirdTeam}
								fourthTeam={matchScarfGroup.fourthTeam}
								otherTeams={matchScarfGroup.otherTeams}
							/>
						);})
					}
				</MatchResultContainer>
				<ScarfContainer>
					{
						matchScarfGroup.scarfCodes.map((x, i) => {
							return (
								<ImageRenderer
									key={i}
									src={`../../../img/scarf/${x}.jpg`}
									title={`${matchScarfGroup.firstTeam?.name} vs ${matchScarfGroup.secondTeam?.name}`}
									alt={`${matchScarfGroup.firstTeam?.name} vs ${matchScarfGroup.secondTeam?.name}`}
									isMobileViewActive={useMobileViewActive}
								/>
							);
						})
					}
					{matchScarfGroup.comment && <ScarfCommentContainer>{matchScarfGroup.comment}</ScarfCommentContainer>}
				</ScarfContainer>
			</GroupContainer>
		);
	}, [useMobileViewActive, renderTitleLogo]);

	return (
		<>
			<Helmet>
				<title>{'Scarves from football games - FootballScarfMuseumCollection'}</title>
			</Helmet>
			<GalleryContainer imgSrc={`M_${imgNumber}`}>
				<MatchCompetitionFilter/>
				<ContentContainer>
					{matchScarfGroups.map((x, i) => renderMatchScarves(x, i))}
				</ContentContainer>
			</GalleryContainer>
		</>
	);
}

export function MatchCompetitionFilter() {

	const dispatch = useAppDispatch()

	const orderByMatchCompetition = useSelector(
		(completeState: IStore): OrderMatchCompetition[] => {
			return completeState.orderAndPaging.orderBy.matchCompetition
		});

	const useMobileViewActive = useSelector(
		(completeState: IStore): boolean => {
			return completeState ? completeState.ui.isMobileViewActive : false
		});

	return (
		<MatchFilterContainer>	
			<ImageFilterSubContainer>
				<StyledFilterImageHeader onClick={() => dispatch(actions.filterCompetition(OrderMatchCompetition.ucl))}>
					<StyledFilterImageContainer isSelected={orderByMatchCompetition.findIndex(x => x === OrderMatchCompetition.ucl) > -1} isMobileView={useMobileViewActive}>
						<img
							title={UCL_NAME}
							src={'../../../img/shield/EU_UCL.png'}
							alt={UCL_NAME}
						/>
					</StyledFilterImageContainer>
					
				</StyledFilterImageHeader>
			</ImageFilterSubContainer>
			<ImageFilterSubContainer>
				<StyledFilterImageHeader onClick={() => dispatch(actions.filterCompetition(OrderMatchCompetition.cwc))}>
					<StyledFilterImageContainer isSelected={orderByMatchCompetition.findIndex(x => x === OrderMatchCompetition.cwc) > -1} isMobileView={useMobileViewActive}>
						<img
							title={CWC_NAME}
							src={'../../../img/shield/FF_CWC.png'}
							alt={CWC_NAME}
						/>
					</StyledFilterImageContainer>
					
				</StyledFilterImageHeader>
			</ImageFilterSubContainer>
			<ImageFilterSubContainer>
				<StyledFilterImageHeader onClick={() => dispatch(actions.filterCompetition(OrderMatchCompetition.fic))}>
					<StyledFilterImageContainer isSelected={orderByMatchCompetition.findIndex(x => x === OrderMatchCompetition.fic) > -1} isMobileView={useMobileViewActive}>
						<img
							title={FIC_NAME}
							src={'../../../img/shield/FF_IC.png'}
							alt={FIC_NAME}
						/>
					</StyledFilterImageContainer>
					
				</StyledFilterImageHeader>
			</ImageFilterSubContainer>
			<ImageFilterSubContainer>
				<StyledFilterImageHeader onClick={() => dispatch(actions.filterCompetition(OrderMatchCompetition.uel))}>
					<StyledFilterImageContainer isSelected={orderByMatchCompetition.findIndex(x => x === OrderMatchCompetition.uel) > -1} isMobileView={useMobileViewActive}>
						<img
							title={UEL_NAME}
							src={'../../../img/shield/EU_UEL.png'}
							alt={UEL_NAME}
						/>
					</StyledFilterImageContainer>
				</StyledFilterImageHeader>
			</ImageFilterSubContainer>
			<ImageFilterSubContainer>
				<StyledFilterImageHeader onClick={() => dispatch(actions.filterCompetition(OrderMatchCompetition.ucw))}>
					<StyledFilterImageContainer isSelected={orderByMatchCompetition.findIndex(x => x === OrderMatchCompetition.ucw) > -1} isMobileView={useMobileViewActive}>
						<img
							title={UCW_NAME}
							src={'../../../img/shield/EU_UCW.png'}
							alt={UCW_NAME}
						/>
					</StyledFilterImageContainer>
					
				</StyledFilterImageHeader>
			</ImageFilterSubContainer>
			<ImageFilterSubContainer>
				<StyledFilterImageHeader onClick={() => dispatch(actions.filterCompetition(OrderMatchCompetition.usc))}>
					<StyledFilterImageContainer isSelected={orderByMatchCompetition.findIndex(x => x === OrderMatchCompetition.usc) > -1} isMobileView={useMobileViewActive}>
						<img
							title={USC_NAME}
							src={'../../../img/shield/EU_USC.png'}
							alt={USC_NAME}
						/>
					</StyledFilterImageContainer>
					
				</StyledFilterImageHeader>
			</ImageFilterSubContainer>
			<ImageFilterSubContainer>
				<StyledFilterImageHeader onClick={() => dispatch(actions.filterCompetition(OrderMatchCompetition.uco))}>
					<StyledFilterImageContainer isSelected={orderByMatchCompetition.findIndex(x => x === OrderMatchCompetition.uco) > -1} isMobileView={useMobileViewActive}>
						<img
							title={COL_NAME}
							src={'../../../img/shield/EU_COL.png'}
							alt={COL_NAME}
						/>
					</StyledFilterImageContainer>
					
				</StyledFilterImageHeader>
			</ImageFilterSubContainer>
			<ImageFilterSubContainer>
				<StyledFilterImageHeader onClick={() => dispatch(actions.filterCompetition(OrderMatchCompetition.ces))}>
					<StyledFilterImageContainer isSelected={orderByMatchCompetition.findIndex(x => x === OrderMatchCompetition.ces) > -1} isMobileView={useMobileViewActive}>
						<img
							title={CES_NAME}
							src={'../../../img/shield/ES_C.png'}
							alt={CES_NAME}
						/>
					</StyledFilterImageContainer>
					
				</StyledFilterImageHeader>
			</ImageFilterSubContainer>
		</MatchFilterContainer>

	);
}



interface IMatchResult {
	readonly yearEnd: number;
	readonly match: IMatch;
	readonly index: number;
	readonly firstTeam?: ITeam;
	readonly secondTeam?: ITeam;
	readonly thirdTeam?: ITeam;
	readonly fourthTeam?: ITeam;
	readonly otherTeams: ITeam[];
}
export function MatchResult({
	yearEnd,
	match,
	index,
	firstTeam,
	secondTeam,
	thirdTeam,
	fourthTeam,
	otherTeams
}: IMatchResult) {

	const dispatch = useAppDispatch();

	const useMobileViewActive = useSelector(
		(completeState: IStore): boolean => {
			return completeState ? completeState.ui.isMobileViewActive : false
		});


	const renderResult = useCallback((match: IMatch, index: number, firstTeam?: ITeam, secondTeam?: ITeam) => {
		return (
			<ResultContainerRow $useMobileViewActive={useMobileViewActive}>
				<ResultContainerResultQuarter $useMobileViewActive={useMobileViewActive}>
					<NumberContainer>{match.localGoals}</NumberContainer>
					<Separator $useMobileViewActive={useMobileViewActive}/>
					{
						match.isExtraTime
							? <TieContainer $useMobileViewActive={useMobileViewActive}>
								<ExtraTimeContainer $useMobileViewActive={useMobileViewActive}>{'aet'}</ExtraTimeContainer>
								{
									match.localPenaltyGoals || match.visitantPenaltyGoals
										? <>
											<LocalPenaltyRenderer $useMobileViewActive={useMobileViewActive}>{`(${match.localPenaltyGoals || 0})`}</LocalPenaltyRenderer>
											<VisitantPenaltyRenderer $useMobileViewActive={useMobileViewActive}>{`(${match.visitantPenaltyGoals || 0})`}</VisitantPenaltyRenderer>
										</>
										: null
								}
							</TieContainer>
							: null
					}
					
				</ResultContainerResultQuarter>
				<ResultContainerResultQuarter $useMobileViewActive={useMobileViewActive}>
					<NumberContainer>{match.visitantGoals}</NumberContainer>
				</ResultContainerResultQuarter>
			</ResultContainerRow>
		);
	}, [useMobileViewActive]);


	if (!firstTeam || !secondTeam) {
		return null;
	}
	const firstMatchTeam = index === 0 ? firstTeam : secondTeam;
	const secondMatchTeam = index > 0 ? firstTeam : secondTeam;
	const localTeamColor = match.homeKitColor || firstMatchTeam.firstColor;
	const awayTeamColor = match.awayKitColor || (localTeamColor === secondMatchTeam.firstColor ? secondMatchTeam.secondColor : secondMatchTeam.firstColor);
	const localYearShield = [...firstMatchTeam.shields].reverse().find((shield: string) => Number.parseInt(shield) >= yearEnd);
	const visitantYearShield = [...secondMatchTeam.shields].reverse().find((shield: string) => Number.parseInt(shield) >= yearEnd);
	const thirdYearShield = thirdTeam ? [...thirdTeam.shields].reverse().find((shield: string) => Number.parseInt(shield) >= yearEnd) : '';
	const fourthTeamYearShield = fourthTeam ? [...fourthTeam?.shields].reverse().find((shield: string) => Number.parseInt(shield) >= yearEnd) : '';
	return (
		<ResultContainer key={index} $useMobileViewActive={useMobileViewActive}>
			<ResultContainerRow $useMobileViewActive={useMobileViewActive}>
				<ResultContainerShieldQuarter backgroundColor={localTeamColor} onClick={e => dispatch(actions.setHomeDetailTeam(firstMatchTeam.teamId))} $useMobileViewActive={useMobileViewActive}>
					<ShieldImageRenderer
						$useMobileViewActive={useMobileViewActive}
						alt={firstMatchTeam.name}
						title={firstMatchTeam.name}
						src={`../../../img/shield/${firstMatchTeam.countryCode}_${firstMatchTeam.teamCode}${localYearShield ? `_${localYearShield}` : ''}.png`}
					/>
				</ResultContainerShieldQuarter>
				{
					!thirdTeam && !fourthTeam && otherTeams.length === 0 && renderResult(match, index, firstMatchTeam, secondMatchTeam)
				}
				<ResultContainerShieldQuarter backgroundColor={awayTeamColor} onClick={e => dispatch(actions.setHomeDetailTeam(secondMatchTeam.teamId))} $useMobileViewActive={useMobileViewActive}>
					<ShieldImageRenderer
						$useMobileViewActive={useMobileViewActive}
						alt={secondMatchTeam.name}
						title={secondMatchTeam.name}
						src={`../../../img/shield/${secondMatchTeam.countryCode}_${secondMatchTeam.teamCode}${visitantYearShield ? `_${visitantYearShield}` : ''}.png`}
					/>
				</ResultContainerShieldQuarter>
				{
					thirdTeam && fourthTeam &&
						<>
							<ResultContainerShieldQuarter backgroundColor={thirdTeam.firstColor} onClick={e => dispatch(actions.setHomeDetailTeam(thirdTeam.teamId))} $useMobileViewActive={useMobileViewActive}>
								<ShieldImageRenderer
									$useMobileViewActive={useMobileViewActive}
									alt={thirdTeam.name}
									title={thirdTeam.name}
									src={`../../../img/shield/${thirdTeam.countryCode}_${thirdTeam.teamCode}${thirdYearShield ? `_${thirdYearShield}` : ''}.png`}
								/>
							</ResultContainerShieldQuarter>
							<ResultContainerShieldQuarter
								backgroundColor={thirdTeam.firstColor === fourthTeam.firstColor ? fourthTeam.secondColor : fourthTeam.firstColor}
								onClick={e => dispatch(actions.setHomeDetailTeam(fourthTeam.teamId))}
								$useMobileViewActive={useMobileViewActive}
							>
								<ShieldImageRenderer
									$useMobileViewActive={useMobileViewActive}
									alt={fourthTeam.name}
									title={fourthTeam.name}
									src={`../../../img/shield/${fourthTeam.countryCode}_${fourthTeam.teamCode}${fourthTeamYearShield ? `_${fourthTeamYearShield}` : ''}.png`}
								/>
							</ResultContainerShieldQuarter>
						</>
				}
				{
					otherTeams.map(team => {
						const teamYearShield = [...team?.shields].reverse().find((shield: string) => Number.parseInt(shield) >= yearEnd);
						return (
							<ResultContainerShieldQuarter backgroundColor={team.firstColor} onClick={e => dispatch(actions.setHomeDetailTeam(team.teamId))} $useMobileViewActive={useMobileViewActive}>
								<ShieldImageRenderer
									$useMobileViewActive={useMobileViewActive}
									alt={team.name}
									title={team.name}
									src={`../../../img/shield/${team.countryCode}_${team.teamCode}${teamYearShield ? `_${teamYearShield}` : ''}.png`}
								/>
							</ResultContainerShieldQuarter>
						);
					})
				}
			</ResultContainerRow>
		</ResultContainer>
	);
}

